<template>
    <div class="m-5">
        <div class="m-5 flex space-x-4 mb-6 text-sm font-medium">

            <div class="flex-auto flex space-x-4">
                <router-link :to="{ name: 'home' }" class="py-2 px-6 rounded-md bg-black text-white">Home</router-link>
                <router-link :to="{ name: 'palettes' }" class="py-2 px-6 rounded-md bg-black text-white">Palettes</router-link>
            </div>

        </div>

        <router-view/>
    </div>
</template>

<script>

export default {
    name: 'ColorsApp',
    data() {
        return {
            viewModel: {},
        }
    },
    methods: {
        methodHere() {

        }
    }
}
</script>
